import React from 'react';
import { useState, useEffect } from 'react';
import { Box} from '@mui/material';
import { stateValuesDos } from '../../../Utils/Utils';

import UpdateEEForm from '../../../Components/Employees/UpdateEEForm';
import LoadingBackDrop from '../../../Components/LoadingBackDrop';
import SnackBar from '../../../Components/SnackBar';
import DialogeConfirmationEE from '../../../Components/Employees/DialogeBoxs/DialogeConfirmationEE';


import { getAllHQBanks,patchBankBranchEE } from '../../Services/BankAPI';

export default function UpdateBankEEForm() {

  const rolesToMap=["bank_banker", "bank_loan_admin"];
  let hqBusinessType = "Bank";
  let confirmationType = "Update";
  let titleAction = "Updating";

  const [companiesArray, setCompaniesArray] = useState([]);
  const[stateInputValue,setStateInputValue]=useState("");
  const [stateValue, setStateValue] = useState(null);

  const [confirmationDialogeBoxOpen, setConfirmationDialogeBoxOpen] = useState(false);
  const [openLoadingBackDrop, setOpenLoadingBackdrop] = useState(false);

  /**
   * SNACK BAR States
   */
  const[alertType,setAlertType] = useState("success");
  const[alertMessage, setAlertMessage]=useState("")
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  

  const [viewBranchField, setViewBranchField] = useState("none");
  const [viewEmployeeSelect, setViewEmployeeSelect] = useState("none")
  const [viewEEFields, setViewEEFields] = useState("none");

  const [companyObjct, setCompanyObjct] = useState({
    hq_id:"",
    hq_company_name:"",
    hq_company_type:"Bank",
    hq_company_address:{
      address:"",
      address_two:"",
      city:"",
      state:"",
      zip:""
  },
    hq_phone:"",
    hq_email:"",
    branches:[]
  });


  const[branchObjct, setBranchObjct] = useState( {
    branch_id:"",
    branch_name:"",
    company_association:{hq_id:""},
    branch_address:{
        address:"",
        addressTwo:"",
        city:"",
        state:"",
        zip:""
    },
    branch_phone:"",
    branch_email:"",
    branch_employees:[]
  });

  const [employeeObjct, setEmployeeObjct] = useState({
    user_id:"",
    first_name:"",
    last_name:"",
    email:"",
    phone:"",
    address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
    username:"",
    passwrd:"",
    rle:"",
    branch_association:{branch_id:""}
  });

  const[eeObjectBeforeUpdate, setEEObjectBeforeUpdate] = useState({
    user_id:"",
    first_name:"",
    last_name:"",
    email:"",
    phone:"",
    address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
    username:"",
    passwrd:"",
    rle:"",
    branch_association:{branch_id:""}
  });

  const [errorObject,setErrorObject] = useState({
    id:false,
    first_name:false,
    last_name:false,
    email:false,
    phone:false,
    address:{
        address:false,
        address_two:false,
        city:false,
        state:false,
        zip:false
    },
    username:false,
    passwrd:false,
    rle:false,
    bank_branch_association:{branch_id:false}

  });

  let initialCompanyObject={
    hq_id:"",
    hq_company_name:"",
    hq_company_type:"Bank",
    hq_company_address:{
      address:"",
      address_two:"",
      city:"",
      state:"",
      zip:""
  },
    hq_phone:"",
    hq_email:"",
    branches:[]
  };

  let initialBranchObjct = {
    branch_id:"",
    branch_name:"",
    hq_company:{hq_id:""},
    branch_address:{
        address:"",
        addressTwo:"",
        city:"",
        state:"",
        zip:""
    },
    branch_phone:"",
    branch_email:"",
    branch_employees:[]
  };

  let initialEmployeeObject = {
    user_id:"",
    first_name:"",
    last_name:"",
    email:"",
    phone:"",
    address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
    username:"",
    passwrd:"",
    rle:"",
    branch_association:{branch_id:""}
  };

  function handleConfirmDialogeBoxClose(){
    setConfirmationDialogeBoxOpen(false);
  }

  function handleLoadingClose(){
    setOpenLoadingBackdrop(false);
  };

  /**
   * OPENS THE SNACKBAR
   */
  const handleSnackBarOpen = () => {
    setSnackBarOpen(true);
  };
    
  /**
   * CLOSES THE SNACK BAR
   */
  const handleSnackBarClosed = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  };


  useEffect(()=>{
    // get all the banks
    const fetchBanks = async () => {
      const allBanksData = await getAllHQBanks();
      console.log(allBanksData.data)
      setCompaniesArray(allBanksData.data);
      return allBanksData.data
    }
    fetchBanks();

  },[]);

  
  // hq object
  function handleHQChosenChange(e){

    let company_id = e.target.value;
    let choosenCompany = findHqCompany(company_id);

    if(choosenCompany){

        setCompanyObjct(choosenCompany);
        setBranchObjct(initialBranchObjct);
        setViewBranchField("block");
        
    }else{

      setViewBranchField("none");
      setViewEmployeeSelect("none");
      setViewEEFields("none");
      setCompanyObjct(initialCompanyObject);
      setBranchObjct(initialBranchObjct);
      setEmployeeObjct(initialEmployeeObject);
        console.log("cant find")
    }

  };

  const findHqCompany = (hq_id) =>{
    let foundHq = companiesArray.filter((hq) => 
        hq.hq_id === hq_id
    );
    if (foundHq.length === 1){
        return foundHq[0];
    }else{
        return null;
    }
  };


  function handleChoosenBranchChange(e){
    let branch_id = e.target.value;

    if(branch_id === null || branch_id === ""){
      setBranchObjct(initialBranchObjct);
      setEmployeeObjct(initialEmployeeObject);
      setViewEmployeeSelect("none");
      setViewEEFields("none");
    }else{

      let branchToUpdate = getBranch(branch_id);
      setBranchObjct(branchToUpdate);
      // setEmployeeObjct(initialEmployeeObject);
      // handleViewingEEChange("view");
      setViewEmployeeSelect("block");
    }

    setEmployeeObjct(initialEmployeeObject);
    
  };
    
  const getBranch = (branch_id) =>{

    let foundBranch = companyObjct.branches.filter((branch) => 
        branch.branch_id === branch_id
    );
    if (foundBranch.length === 1){
        return foundBranch[0];
    }else{
        return null;
    }
  };

  function handleChoosenEmployeeChange(e){
    let ee_id = e.target.value;

    if(ee_id === null || ee_id === ""){

      setViewEEFields("none");
      setEmployeeObjct(initialEmployeeObject);
      setEEObjectBeforeUpdate(initialEmployeeObject);
    }else{

      let eeToUpdate = getEmployee(ee_id);
      eeToUpdate.branch_association = {branch_id:e.target.value}
      setEmployeeObjct(eeToUpdate);
      setEEObjectBeforeUpdate(eeToUpdate);
      let eeAddressState = eeToUpdate.address.state;
  
      let stateOpt = stateValuesDos.filter((opt) => 
          opt.index === eeAddressState
      );
  
      if(stateOpt.length > 0){
  
        setStateValue(stateOpt[0]);
        setStateInputValue(stateOpt[0].index);
      };

      setViewEEFields("block");
    }

    

  };

  function getEmployee(employee_id){
    let foundEE = branchObjct.branch_employees.filter((ee) => 
      ee.user_id === employee_id
    );
    if (foundEE.length === 1){
        return foundEE[0];
    }else{
        return null;
    }
  };
    
  // handle update of first_name
  function handleFirstNameChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      first_name:e.target.value
    })
  };
  // handle update of last_name
  function handleLastNameChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      last_name:e.target.value
    })
  };
  // handle email update
  function handleEmailChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      email:e.target.value
    })
  };

  // handle phone update
  function handlePhoneChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      phone:e.target.value
    })
  };
  // handle role update
  function handleRoleChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      rle:e.target.value
    })
  };
  // handle address update
    
  
  // address
  function handleAddressChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      address:{
        ...employeeObjct.address,
        address:e.target.value
      }
    });
  };
  
  // addressTwo
  function handleAddressTwoChange(e){

    setEmployeeObjct({
      ...employeeObjct,
      address:{
        ...employeeObjct.address,
        address_two:e.target.value
      }
    });
  };
  
  // city
  function handleCityChange(e){
  
    setEmployeeObjct({
      ...employeeObjct,
      address:{
        ...employeeObjct.address,
        city:e.target.value
      }
    });
  };
  
  // state
  function handleStateChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      address:{
        ...employeeObjct.address,
        state:e.index
      }
    });
  };
  
  // zip
  function handleZipChange(e){

    setEmployeeObjct({
      ...employeeObjct,
      address:{
        ...employeeObjct.address,
        zip:e.target.value
      }
    });
  };

  // handle username update
  function handleUserNameChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      username:e.target.value
    })
  };

  // handle password update
  function handlePasswordChange(e){
    setEmployeeObjct({
      ...employeeObjct,
      passwrd:e.target.value
    })
  };





  /**
   * Error Validating The Form
   */
  function formErrorValidation(e){
    e.preventDefault();
    let foundError = false;
    let copiedErrObjct = {...errorObject}
    
    if(employeeObjct.first_name === "" || employeeObjct.first_name === null ){

      copiedErrObjct.first_name = true;
      foundError = true;
    };

    if(employeeObjct.last_name === "" || employeeObjct.last_name === null ){
      copiedErrObjct.last_name = true;
      foundError = true;
    };


    if(employeeObjct.rle === "" || employeeObjct.rle === null ){
      copiedErrObjct.rle = true;
      foundError = true;
    };

    if(employeeObjct.passwrd === "" || employeeObjct.passwrd === null ){
      copiedErrObjct.passwrd = true;
      foundError = true;
    };
    if(employeeObjct.username === "" || employeeObjct.username === null ){
      copiedErrObjct.username = true;
      foundError = true;
    };

    setErrorObject(copiedErrObjct)

    if(!foundError){
      testConfirmAddCompanyConfirmationBox();
    }
  };

  /***
   * Handles the submit button from form component
   */
  function testConfirmAddCompanyConfirmationBox(){
    setConfirmationDialogeBoxOpen(true)
  };


  /***
   * Handles the response from the confirmation dialoge box
   */
  function dialogeConfirmationBoxAnswerHandle(resp){
    console.log("handling answer");
    console.log("The answer is === " + resp);
    if(resp === "Agree"){
      setConfirmationDialogeBoxOpen(false);
      setOpenLoadingBackdrop(true);
      submitEEUpdate();
    }else{
      setConfirmationDialogeBoxOpen(false);
    }
  };

  /***
   * Handles adding a new branch
   */
  async function submitEEUpdate(){
    console.log(employeeObjct)
    let resp = await patchBankBranchEE(employeeObjct);
    if (resp.error){
      setAlertType("error");
      setAlertMessage(`There was an error ${titleAction}ing the ${hqBusinessType} Branch employee.`);
    }else{
      setOpenLoadingBackdrop(false);
      setAlertType("success");
      setAlertMessage(`The ${hqBusinessType} branch employee has been successfully updated.`);
      handleSnackBarOpen();
      addUpdatedItemToArray();
      clearForm();
    }
    
  };


  /**
   * Replaces the updated item with the newly updated item
   */
  function addUpdatedItemToArray(){


    // UPDATE THE EMPLOYEES ARRAY OF BRANCH
    // UPDATE THAT ARRAY IN THE BRANCH OBJECT
    // UPDATE THE BRANCH OBJECT IN THE COMPANIES BRANCH ARRAY.
    let copiedCompaniesArray = [...companiesArray];
    let clonedCompany = {...companyObjct}

    let copiedEEArray = [...branchObjct.branch_employees];
    let clonedEE= {...employeeObjct}

    let clonedBranch = {...branchObjct}
    const modifiedBranchEmployees = copiedEEArray.map(obj => {

      if (obj.id === clonedEE.id) {
          console.log("found it");
          return clonedEE;
      }
      return obj;
    });

    clonedBranch.branch_employees = modifiedBranchEmployees;

    const modifiedBranches = clonedCompany.branches.map(branchObj =>{
      if(branchObj.branch_id === clonedBranch.branch_id){
        return clonedBranch;
      }
      return branchObj;
    });

    clonedCompany.branches = modifiedBranches;

    const modifiedCompanies = copiedCompaniesArray.map(obj => {

      if (obj.hq_id === clonedCompany.hq_id) {
          console.log("found it");
          return clonedCompany;
      }
      return obj;
  });
    setCompaniesArray(modifiedCompanies);

    // let copiedBranches = [...branchObjct.branch_employees];
    // let branchEE= {...employeeObjct}

    // const modifiedBranches = copiedEEArray.map(obj => {

    //   if (obj.id === clonedEE.id) {
    //       console.log("found it");
    //       return clonedEE;
    //   }
    //   return obj;
    // });
    // setCompaniesArray(modifiedCompanies);
    // setBranchEmployees(modifiedEmployees)
  };


  /**
   * Resets the companyObject so the form is cleared.
   */
  function clearForm(){
    // setCompanyObjct(initialBranchObjct);
    setCompanyObjct(initialCompanyObject)
    setBranchObjct(initialBranchObjct);
    setEmployeeObjct(initialEmployeeObject);
    setEEObjectBeforeUpdate(initialEmployeeObject);
  };


  return (
    <Box>
       <UpdateEEForm 
          errorValidator={errorObject}
          addWhatBranchTitle={hqBusinessType}
          addWhatCompanyTitle = {hqBusinessType}
          hqsToMap={companiesArray}
          rolesToMap={rolesToMap}
          branchesToMap={companyObjct.branches}

          hqObjct={companyObjct}
          handleHQChange={handleHQChosenChange}


          branchObjct={branchObjct}
          handleChoosenBranchChange={handleChoosenBranchChange}

          employeeObjct={employeeObjct}
          handleChoosenEmployeeChange={handleChoosenEmployeeChange}

          viewBranchField={viewBranchField}
          viewEmployeeSelect={viewEmployeeSelect}
          viewEEFields={viewEEFields}

          handleFirstNameChange={handleFirstNameChange}
          handleLastNameChange={handleLastNameChange}
          handleEmailChange={handleEmailChange}
          handlePhoneChange={handlePhoneChange}

          handleRoleChange={handleRoleChange}
          handleUserNameChange={handleUserNameChange}
          handlePasswordChange={handlePasswordChange}

          handleAddressChange={handleAddressChange}
          handleAddressTwoChange={handleAddressTwoChange}
          handleCityChange={handleCityChange}
          handleStateChange={handleStateChange}
          stateValue={stateValue}
          setStateValue = {setStateValue}
          stateInputValue={stateInputValue}
          setStateInputValue={setStateInputValue}
          handleZipChange={handleZipChange}

          submitUpdatedEmployee={formErrorValidation}
        />
        <DialogeConfirmationEE
          confirmationType={confirmationType}
          titleAction={titleAction}

          intialUpdatedObject={eeObjectBeforeUpdate}
          updatedObject={employeeObjct}

          addWhatCompanyType={hqBusinessType}
          hqCompanyObject={companyObjct}
          branchObject={branchObjct}
          confirmationDialogeBoxOpen={confirmationDialogeBoxOpen}
          dialogeConfirmationBoxAnswerHandle={dialogeConfirmationBoxAnswerHandle}
          handleConfirmDialogeBoxClose={handleConfirmDialogeBoxClose}
        />
        <LoadingBackDrop
          openLoadingBackDrop={openLoadingBackDrop}
          handleLoadingClose={handleLoadingClose}
        />
        <SnackBar
          handleSanckBarOpen={handleSnackBarOpen}
          handleSnackBarClosed={handleSnackBarClosed}
          snackBarState = {snackBarOpen}
          alertType={alertType}
          alertMessage={alertMessage}
        />
     
    </Box>
  )
}
